var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"1px"}},[_c('Stack',{attrs:{"monitor-images-loaded":"","column-min-width":320,"gutter-height":-1}},_vm._l((_vm.shuffledNumbers(41)),function(i){return _c('StackItem',{key:i,staticClass:"img-container"},[_c('img',{attrs:{"src":require(`@/assets/gallery/${i}.jpg`)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }